import { GET, POST, DEVURL, Axios } from "../config";

export const list = () => GET("shared/backups/");
export const create = () => POST("shared/backups/create_backup/");
export const download = (id) => Axios.get(`shared/backups/${id}/download/`, { responseType: 'blob' });
// Helper para obtener la URL de descarga (relativa al dominio actual)
export const getDownloadUrl = (id) => `${DEVURL}/shared/backups/${id}/download/`;
